import type {Iso8601Time} from "@vesta/common-type-definitions/typeDefinitions";
import {iso8601TimeZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod} from "zod";

export type AgentViewWorkingHours = {
    endTime: Iso8601Time;
    startTime: Iso8601Time;
};

export type AgentViewWorkspaceCapabilityConfiguration = {
    dynamicQueueCutoffTime: Iso8601Time;
    workingHours: AgentViewWorkingHours;
};

export const agentViewWorkingHoursValidator: zod.ZodType<AgentViewWorkingHours> = zod.strictObject({
    endTime: iso8601TimeZodValidator,
    startTime: iso8601TimeZodValidator,
});

export const agentViewWorkspaceCapabilityConfigurationValidator: zod.ZodType<AgentViewWorkspaceCapabilityConfiguration> = zod.strictObject({
    dynamicQueueCutoffTime: iso8601TimeZodValidator,
    workingHours: agentViewWorkingHoursValidator,
});
